export const getPagingLimits = pager => {
  const { page, pageSize } = pager;

  const indexOfLastItem = page * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;

  return { indexOfFirstItem, indexOfLastItem };
};

export const filterByValue = (verifications, filter) => {
  return verifications.filter(o =>
    Object.keys(o).some(k => {
      if (o[k] !== null && (k === "name" || k === "contractTypeName"))
        return o[k].toString().toLowerCase().includes(filter.toString().toLowerCase());
      return null;
    })
  );
};
